import equal from 'deep-equal'
import { useAtomValue } from 'jotai'
import React from 'react'

import { surveyFilterAtom } from '~/atoms'
import { nineNumbers } from '~/utils'

import {
  isPendingTabulationAtom,
  isTabulatableAtom,
  isTabulationFetchingAtom,
  isTabulationReadyAtom,
  lastTabulationParamsAtom,
  tabulationDataAtom,
} from '../atoms'

import { type TabulationDataItem } from './transformWhoAndWhatResult'
import { useTriggerTabulation } from './useTriggerTabulation'

export const useTabulationQuery = () => {
  const isTabulationFetching = useAtomValue(isTabulationFetchingAtom)
  const isTabulationReady = useAtomValue(isTabulationReadyAtom)
  const isPendingTabulation = useAtomValue(isPendingTabulationAtom)
  const isTabulatable = useAtomValue(isTabulatableAtom)
  const surveyFilter = useAtomValue(surveyFilterAtom)
  const lastTabulationParams = useAtomValue(lastTabulationParamsAtom)
  const triggerTabulation = useTriggerTabulation()

  React.useEffect(() => {
    // 集計実行中、集計済みでない、またはブランド/設問の変更がある場合は何もしない（ボタン押下待ち）
    if (
      isTabulationFetching ||
      !isTabulationReady ||
      isPendingTabulation ||
      !isTabulatable
    ) {
      return
    }
    // 絞り込みが前回と同一なら不要（無限ループ防止）
    if (
      lastTabulationParams !== null &&
      equal(lastTabulationParams.surveyFilter, surveyFilter ?? null)
    ) {
      return
    }
    void triggerTabulation()
  }, [
    isTabulatable,
    isPendingTabulation,
    isTabulationReady,
    isTabulationFetching,
    surveyFilter,
    lastTabulationParams,
    triggerTabulation,
  ])

  return isTabulationFetching
}

export const useIsTabulationFetching = () =>
  useAtomValue(isTabulationFetchingAtom)

export const useTabulationData = (): TabulationDataItem[] => {
  const tabulationData = useAtomValue(tabulationDataAtom)

  if (!tabulationData) {
    return nineNumbers.map((nineNumber) => ({
      nineNumber,
      count: NaN,
      ratio: NaN,
    }))
  }

  return tabulationData
}
